import EmailTemplates from './EmailTemplates';

export default EmailTemplates;
